// extracted by css-extract-rspack-plugin
export default {"destructive":"iiw8EmdMots7ViO6"};